<template>
  <div class="pc_container_inner">
    <SuccessDialog
      SuccessTitle="恭喜您抢单成功！"
      :show="showSuccessDialog"
      @close="closeSuccessDialog"
    />
    <div class="get_new_one">
      <div class="follow_new">
        <div class="title">
          <div class="title_left" v-if="hasNewClue">新的抢单信息</div>
          <div class="title_no_left" v-else>暂无可抢单信息</div>
          <div
            class="title_right"
            @click="$router.push('/pc/follow/swPendingFollow')"
          >
            更多
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <template v-if="hasNewClue">
          <SWFollowListItem
            style="margin-top: -24px"
            v-for="item in newClueList"
            :key="item.id"
            :item="item"
            type="swGetFollow"
            @sw-get-follow="acceptPreOrder"
            @sw-block-follow="blockPreOrder"
          ></SWFollowListItem>
        </template>
      </div>
    </div>
    <div v-if="preOrderList && preOrderList.length > 0" class="follow_box">
      <SWFollowListItem
        v-for="item in preOrderList"
        :key="item.id"
        :item="item"
        :class="['same', tableRowClassName(item)]"
      ></SWFollowListItem>
    </div>
    <div v-else>
      <van-empty description="暂无数据" />
    </div>
  </div>
</template>

<script>
import SWFollowListItem from "@/components/pc/SWFollowListItem.vue";
import SuccessDialog from "@/components/pc/SuccessDialog.vue";
import { getUserInfoDetail } from "@/api/user";
import { getMyFollowList } from "@/api/MyFollow";
import {
  swPendingFollowList,
  followUp,
  blockBizOpporMsg,
} from "@/api/bizOppor";

export default {
  name: "SW_TPR",
  watch: {},
  components: {
    SWFollowListItem,
    SuccessDialog,
  },
  data() {
    return {
      showSuccessDialog: false, // 控制成功弹窗显示
      //状态1已提交2谈判人已接单3商务已接单4已生成合同5已确认金额6买家已支付7货主已支付9交易完成
      tabList: [
        { title: "全部", status: null, name: "all" },
        // { title: "待处理", status: 3, name: "wait" },
        // { title: "交易中", status: 4, name: "jy" },
        // { title: "待支付", status: 5, name: "zf" },
        // { title: "交易完成", status: 9, name: "wc" },
      ],
      tabs: [{ title: "商务跟单", name: "swFollow" }],
      active: 0,
      params: {
        pageSize: 10,
        pageNum: 1,
        status: null,
      },
      isEdit: false,
      userInfo: {
        businessType: null,
      },
      preOrderList: [],
      preOrderTotal: 0,

      clueFollowList: [],
      clueFollowTotal: 0,
      preOrderFollowList: [],
      preOrderFollowTotal: 0,
      newClueList: [], // 新订单列表
      hasNewClue: false, //是否有新订单
    };
  },
  computed: {},

  created() {
    this.getUserInfo();
    this.pendingSWFollowPreOrderList();
  },
  methods: {
    // 自定义行样式类名
    tableRowClassName(item) {
      // 当status等于9时，返回自定义类名
      return item.status == 0 ? "stop-row" : "";
    },
    get(value) {
      this.params.allSearch = value;
      this.getMySwFollowPreOrderList();
    },
    // 查看是否有新订单
    async pendingSWFollowPreOrderList() {
      swPendingFollowList().then((resp) => {
        this.hasNewClue = resp.rows.length > 0;
        var item = resp.rows?.[0];
        if (!item) return;
        if (item.clueType == 1) {
          item.peopleList = [
            {
              text: "货主",
              name: item.ownerName || "",
              phone: item.ownerMobile || "",
              wx: item.ownerWx || "",
              avatar: item.ownerAvatar || "",
            },
            {
              text: "采购谈判人",
              name: item.sellerNegotiatorName || "",
              phone: item.sellerNegotiatorMobile || "",
              wx: item.sellerNegotiatortWx || "",
              avatar: item.sellerNegotiatorAvatar || "",
            },
          ];
        } else {
          item.peopleList = [
            {
              text: "采购商务",
              name: item.sellerBusinessName || "",
              phone: item.sellerBusinessMobile || "",
              wx: item.sellerBusinessWx || "",
              avatar: item.sellerBusinessAvatar || "",
            },
            {
              text: "销售谈判人",
              name: item.buyerNegotiatorName || "",
              phone: item.buyerNegotiatorMobile || "",
              wx: item.buyerNegotiatorWx || "",
              avatar: item.buyerNegotiatorAvatar || "",
            },
          ];
        }
        this.newClueList = [item];
      });
    },
    onTab(index) {
      this.active = index;
      this.params.status = this.tabList[index].status;
      this.getMySwFollowPreOrderList();
    },
    async getUserInfo() {
      const response = await getUserInfoDetail();
      if (response.code === 200) {
        this.userInfo = response.data.userInfo;
        this.getMySwFollowPreOrderList();
      }
    },
    /**
     * 获取我的商务跟单预订单列表
     */
    async getMySwFollowPreOrderList() {
      getMyFollowList(this.params).then((resp) => {
        this.preOrderList = resp.rows || [];
        this.preOrderTotal = resp.total;
        if (this.preOrderList.length == 0) return;
        this.preOrderList.forEach((item) => {
          this.handleData(item);
        });
      });
    },
    handleData(item) {
      // type 10-线索跟单 20-商品跟单 30-交易跟单
      // if (item.type == 10) {
      //   item.peopleList = [
      //     {
      //       text: `${item.model == 1 ? "货主" : "买家"}`,
      //       name: item.ownerName || "",
      //       phone: item.ownerMobile || "",
      //       wx: item.ownerWx || "",
      //       avatar: item.ownerAvatar || "",
      //     },
      //     {
      //       text: `${item.model == 1 ? "货主信息提供人" : "买家信息提供人"}`,
      //       name: item.contactName || "",
      //       phone: item.contactMobile || "",
      //       wx: item.contactWx || "",
      //       avatar: item.contactAvatar || "",
      //     },
      //   ];
      // } else
      if (item.type == 20) {
        // model 1 货主 2 买家
        if (item.model == 1) {
          // 采购商务接单
          item.peopleList = [
            {
              text: "货主",
              name: item.ownerName || "",
              phone: item.ownerMobile || "",
              wx: item.ownerWx || "",
              avatar: item.ownerAvatar || "",
            },
            {
              text: "采购谈判人",
              name: item.sellerNegotiatorName || "",
              phone: item.sellerNegotiatorMobile || "",
              wx: item.sellerNegotiatorWx || "",
              avatar: item.sellerNegotiatorAvatar || "",
            },
          ];
        } else if (item.model == 2) {
          // 目前没有这种情况
          item.peopleList = [];
        }
      } else if (item.type == 30) {
        // model 1 货主 2 买家
        if (item.model == 1) {
          // 销售商务接单
          if (item.buyerBusinessName) {
            item.peopleList = [
              {
                text: "销售商务",
                name: item.buyerBusinessName || "",
                phone: item.buyerBusinessMobile || "",
                wx: item.buyerBusinessWx || "",
                avatar: item.buyerBusinessAvatar || "",
              },
              {
                text: "验货人",
                name: item.inspectorUserName || "",
                phone: item.inspectorUserMobile || "",
                wx: item.inspectorUserWx || "",
                avatar: item.inspectorUserAvatar || "",
              },
            ];
          }
          // 销售谈判人接单
          else if (item.buyerNegotiatorName) {
            item.peopleList = [
              {
                text: "采购谈判人",
                name: item.sellerNegotiatorName || "",
                phone: item.sellerNegotiatorMobile || "",
                wx: item.sellerNegotiatorWx || "",
                avatar: item.sellerNegotiatorAvatar || "",
              },
              {
                text: "销售谈判人",
                name: item.buyerNegotiatorName || "",
                phone: item.buyerNegotiatorMobile || "",
                wx: item.buyerNegotiatorWx || "",
                avatar: item.buyerNegotiatorAvatar || "",
              },
            ];
          }
        } else if (item.model == 2) {
          // 销售商务接单
          if (item.sellerBusinessName) {
            item.peopleList = [
              {
                text: "买家",
                name: item.ownerName || "",
                phone: item.ownerMobile || "",
                wx: item.ownerWx || "",
                avatar: item.ownerAvatar || "",
              },
              {
                text: "采购商务",
                name: item.sellerBusinessName || "",
                phone: item.sellerBusinessMobile || "",
                wx: item.sellerBusinessWx || "",
                avatar: item.sellerBusinessAvatar || "",
              },
              {
                text: "采购谈判人",
                name: item.contactName || "",
                phone: item.contactMobile || "",
                wx: item.contactWx || "",
                avatar: item.contactAvatar || "",
              },
              // {
              //   text: "销售谈判人",
              //   name: item.buyerNegotiatorName || "",
              //   phone: item.buyerNegotiatorMobile || "",
              //   wx: item.buyerNegotiatorWx || "",
              //   avatar: item.buyerNegotiatorAvatar || "",
              // },
            ];
          }
        }
      }
    },
    viewDetail(item) {
      this.$router.push("/preOrderDetail/" + item.id);
    },
    // 抢单
    acceptPreOrder(order) {
      followUp({ id: order.id, identity: "20" }).then((resp) => {
        if (resp.code == 200) {
          // 显示成功弹窗
          this.showSuccessDialog = true;

          // 2秒后自动关闭弹窗并跳转页面
          this.dialogTimeout = setTimeout(() => {
            this.showSuccessDialog = false;
            this.closeSuccessDialog();
          }, 2000);
        } else if (resp.code == 500) {
          this.$message.error(resp.msg);
        }
      });
    },
    //关闭成功弹窗提示框
    closeSuccessDialog() {
      if (this.showSuccessDialog) {
        clearTimeout(this.dialogTimeout);
      }
      this.showSuccessDialog = false;
      this.pendingSWFollowPreOrderList();
      this.getMySwFollowPreOrderList();
    },
    // 屏蔽订单
    blockPreOrder(order) {
      this.$confirm("确定屏蔽该条信息吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 屏蔽类型：10-谈判人屏蔽，20-商务屏蔽
          blockBizOpporMsg({ bizMsgId: order.id, blockType: 20 }).then(
            (resp) => {
              if (resp.code == 200) {
                this.$message({
                  message: "屏蔽成功",
                  type: "success",
                  duration: 2000, // 提示显示时长
                  onClose: () => {
                    // 提示关闭后执行接口刷新
                    this.pendingSWFollowPreOrderList();
                  },
                });
              } else if (resp.code == 500) {
                this.$message.error(resp.msg);
              }
            },
          );
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
// 最新的一条信息卡片

.get_new_one {
  width: 100%;
  margin-top: 35px;
  padding: 0 24px;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #d8d8d8;

  .follow_new {
    display: flex;
    flex-direction: column;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 18px;
      margin: 24px 0;

      .title_left,
      .title_no_left {
        display: flex;
        align-items: center;
        gap: 12px;
        color: #3b3b3b;
      }

      .title_left::before {
        content: ""; //必须设置content为空，否则伪元素不显示
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background-color: #f95348;
      }
      .title_right {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #4286f5;
      }
    }
  }
}
// 跟单列表
.follow_box {
  width: 100%;
  .same {
    padding: 36px 0;
  }
}
</style>
